import { FormInstance } from 'antd';

interface UseFiltersProps {
  form: FormInstance;
  resetFilters: () => void;
}

export const useFilters = ({ form, resetFilters }: UseFiltersProps) => {
  const clearFilters = () => {
    form.resetFields();
    resetFilters();
  };

  return { clearFilters };
};
